import { PortalStatus } from '@services/src/models';

export const valueMap = new Map<PortalStatus, string>([
	[PortalStatus.Access, 'Access'],
    [PortalStatus.NotSent, 'Not sent'],
    [PortalStatus.Sent, 'Sent'],

]);

export const map = (value: PortalStatus): string => valueMap.get(value) ?? '';